import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DONE_IMAGE, LOGIN_REACHIQ_LOGO } from "../../utils/constants/assets";
import { RED_COLOR } from "../../theme/colors";
import { CURRENT_YEAR } from "../../utils/constants";
import { Anchor } from "../../components";
import {
  CONNECTOME_LINK,
  DO_NOT_SELL_LINK,
  PRIVACY_POLICY_LINK,
  REACHIQ_HOME,
  TERMS_SERVICE_LINK,
} from "../../utils/constants/httpConstants";

const styles = makeStyles({
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  leftFooter: {
    display: 'flex'
  },
  containLogo: {
    display: "flex",
    justifyContent: "center",
    margin: "10vh 20vw",
  },
  logo: {
    width: "clamp(90px,11vw,220px)",
    height: "clamp(90px,11vh,220px)",
    objectFit: "contain",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 1rem",
  },
  title: {
    color: "#102F51",
    fontFamily: "inter_300",
    fontSize: "clamp(1.4rem, 2.5vw, 4.5rem)",
    letterSpacing: "1x",
    marginBottom: "2vh",
    textAlign: "center",
  },
  para: {
    color: "#626B7E",
    fontFamily: "inter_400",
    fontSize: "clamp(0.9rem, 1vw, 2.5rem)",
    marginBottom: "4vh",
    textAlign: "center",
  },
  red: {
    color: "#ff4848",
  },
  button: {
    backgroundColor: RED_COLOR,
    color: "white",
    fontSize: "clamp(0.9rem, 1vw, 2.5rem)",
    padding: "1rem 4rem",
    border: "none",
    borderRadius: "8px",
    marginLeft: "0.6rem",
    cursor: "pointer",
    boxShadow: "0px 9px 20px #ff16543c",
    fontFamily: "inter_500",
  },
  containFooter: {
    position: "absolute",
    display: "flex",
    justifyContent: "space-around",
    padding: "4vh 0 0 0",
    borderTop: "1px solid #d3dae3",
    bottom: 0,
    width: "100%",
  },
  policyPara: {
    color: "#626B7E",
    fontFamily: "inter_400",
    fontSize: "clamp(0.8rem, 0.9vw, 2.5rem)",
    marginBottom: "4vh",
    textAlign: "center",
    cursor: "pointer",
  },
  privacyLink: {
    fontFamily: "inter_500",
    fontSize: "clamp(0.8rem, 0.9vw, 2.5rem)",
    marginBottom: "4vh",
    textAlign: "center",
    cursor: "pointer",
    textDecoration: "none",
    paddingRight: "4px",
    color: "#626B7E",
    transition: "100ms",
    "&:hover": {
      color: "#ff4848",
    },
  },
});

const ThankYouScreen = ({ email }) => {
  const classes = styles();

  const handleNavigate = () => {
    // navigate( HOME_PATH )
    window.location.replace(REACHIQ_HOME);
  };

  return (
    <Box className={classes.container}>
      <Box>
        <Box className={classes.containLogo}>
          <img src={LOGIN_REACHIQ_LOGO} className={classes.logo} alt="" />
        </Box>
      </Box>
      <Box className={classes.content}>
        <img src={DONE_IMAGE} className={classes.logo} alt="" />
        <h2 className={classes.title}>
          Thank you for <span className={classes.red}>Signing up</span> for
          ReachIQ!
        </h2>
        <p className={classes.para}>
          We have sent an email verification link {" "}
          {email ? <span className={classes.red}>on {email}</span> : null}
        </p>
        <button className={classes.button} onClick={handleNavigate}>
          Go Home{" "}
        </button>
      </Box>
      <Box className={classes.containFooter}>
        <Box className={classes.leftFooter} >
          <p className={classes.policyPara}>
            &#169; {CURRENT_YEAR}
          </p>
          <Anchor
            href={CONNECTOME_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            &nbsp;
            Connectome Inc.
          </Anchor>
          <p className={classes.policyPara} >All Rights Reserved.</p>

        </Box>
        <Box className={classes.policyPara}>
          <Anchor
            href={TERMS_SERVICE_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            Terms of Service |
          </Anchor>

          <Anchor
            href={PRIVACY_POLICY_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            Privacy Policy |
          </Anchor>
          <Anchor
            href={DO_NOT_SELL_LINK}
            className={classes.privacyLink}
            target="_blank"
          >
            Do not sell my information
          </Anchor>
        </Box>
      </Box>
    </Box>
  );
};

export default ThankYouScreen;
